import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { Observable, of, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'omniSummaryCardDatetimePipe',
})
export class OmniSummaryCardDatetimePipe implements PipeTransform {
  transform(date: string): Observable<string> {
    if (date && typeof date === 'string') {
      const dateMoment = moment(date);
      if (!dateMoment.isValid()) {
        return of('--');
      }

      const timerInterval = moment().isSame(dateMoment, 'd')
        ? 60000
        : undefined;

      return timer(0, timerInterval).pipe(
        map(() => {
          const now = moment();
          const yesterday = now.clone().subtract(1, 'day');

          if (now.diff(dateMoment, 'm') <= 2) {
            return 'Now';
          }
          if (dateMoment.isSame(now, 'd')) {
            return moment(date)
              .format('h:mm A')
              .toString();
          }
          if (dateMoment.isSame(yesterday, 'd')) {
            return 'Yesterday';
          }

          return moment(date).format('M/D/YY');
        }),
      );
    }
    return of('--');
  }
}
